import React from "react";
import Box from "ReusableComponents/Box";
import FeatureInfo from "./FeatureInfo";

const FeatureSection = ({ list, small }) => {
  return (
    <Box display="flex" alignItems="center">
      <FeatureInfo list={list} small={small} />
    </Box>
  );
};

export default FeatureSection;
